import React from 'react';

const HomeLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  return (
    <main id="app" className="w-full bg-bg-primary">
      {children}
    </main>
  );
};

export default HomeLayout;
